/*
 * FractalAI bilingual file header.
 *
 * 文件职责 / File Purpose
 * - 中文：前端共享工具模块。提供路由、资产类型、图表偏好、时间周期、格式化和数据适配等跨页面复用能力。
 * - English: Frontend shared utility module. Provides shared routing, asset-type, chart preference, resolution, formatting, and data-adapter helpers.
 *
 * 调用关系 / Call Flow
 * - 被调用 / Called by: 由多个页面、组件、验证路由和图表引擎调用。
 * - Called by (EN): Called by multiple pages, components, validation routes, and chart engines.
 * - 主要依赖 / Main deps: 无显式 import/require；可能是纯配置、常量或框架入口。
 * - 接口/服务信号 / API or service signals: 未在文件内直接声明 endpoint 或 ctx.service 调用。
 * - 关键符号 / Key symbols: buildStrategySlug, buildReportSlug, buildCategorySlug, findItemBySlug, buildStrategyDetailPath, buildReportDetailPath, buildReportCategoryPath, decodeRouteParam
 *
 * 数据与业务边界 / Data and Business Boundaries
 * - 中文：工具函数应保持纯净可测试；资产类型逻辑必须与 BFF 版本同步。
 * - English: Utilities should stay pure and testable; asset-type logic must stay aligned with the BFF version.
 *
 * 修改注意 / Change Notes
 * - 中文：修改公共工具前先搜索调用方，避免破坏兼容页面。
 * - English: Search callers before changing shared utilities to avoid breaking compatibility pages.
 */
const slugifySegment = (value) =>
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

const buildFallback = (prefix) => `${prefix}-${Date.now()}`;

export const buildStrategySlug = (item) =>
  slugifySegment(item?.strategy || item?.name || item?.filename) || buildFallback('strategy');

export const buildReportSlug = (item) =>
  slugifySegment(item?.filename || item?.name || item?.category) || buildFallback('report');

export const buildCategorySlug = (category) =>
  slugifySegment(category) || 'uncategorized';

export const findItemBySlug = (items, slug, builder) =>
  (items || []).find((item) => builder(item) === slug) || null;

export const buildStrategyDetailPath = (item) => `/strategy/${buildStrategySlug(item)}`;

export const buildReportDetailPath = (item) => `/reports/${buildReportSlug(item)}`;

export const buildReportCategoryPath = (category) => `/reports/category/${buildCategorySlug(category)}`;

export const decodeRouteParam = (value) => decodeURIComponent(value || '');
